<script setup lang="ts">
import { ref } from 'vue';

import Button from 'primevue/button';
import Popover from 'primevue/popover';

import UserAvatar from '../components/UserAvatar.vue';
import LogoutButton from '../components/LogoutButton.vue';

const op = ref();
</script>

<template>
  <Button
    class="!bg-transparent hover:!bg-slate-800"
    severity="secondary"
    text
    @click="(event: MouseEvent) => op.toggle(event)"
  >
    <UserAvatar />
    <i class="pi pi-chevron-down text-white" />
  </Button>

  <Popover
    ref="op"
    :pt="{
      root: {
        class: 'after:hidden before:hidden ',
      },
    }"
  >
    <div class="-m-2 w-56">
      <LogoutButton />
    </div>
  </Popover>
</template>
